import { useEffect, useState } from "react";
import {
  EventType,
  type AuthenticationResult,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, setMsalInitializingDone } from "@/lib/msal/instance";

export function MsalAuthProvider({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false);
  const [initError, setInitError] = useState<string | null>(null);

  useEffect(() => {
    msalInstance
      .initialize()
      .then(() => {
        msalInstance
          .handleRedirectPromise()
          .then((response) => {
            if (response) {
              msalInstance.setActiveAccount(response.account);
            } else {
              const accounts = msalInstance.getAllAccounts();
              if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
              }
            }
          })
          .catch((error) => {
            console.error("MSAL handleRedirectPromise failed:", error);
            setInitError("Authentication redirect failed. Please try again.");
          })
          .finally(() => {
            setMsalInitializingDone();
            setIsInitialized(true);
          });

        msalInstance.addEventCallback((event) => {
          if (
            event.eventType === EventType.LOGIN_SUCCESS &&
            event.payload
          ) {
            const result = event.payload as AuthenticationResult;
            msalInstance.setActiveAccount(result.account);
          }
        });
      })
      .catch((error) => {
        console.error("MSAL initialization failed:", error);
        setInitError("Authentication initialization failed. Please refresh the page.");
        setIsInitialized(true);
      });
  }, []);

  if (!isInitialized) {
    return null;
  }

  if (initError) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "#dc2626" }}>
        <p>{initError}</p>
      </div>
    );
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
